import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { ITheme, IThemeOptions } from 'core/style/interfaces';
import createThemeCore from 'core/style/createTheme';

const DEFAULT_BREAKPOINTS = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1170,
    xl: 1920,
};

const createTheme = ({ breakpoints = {}, componentStyles = {}, colors }: IThemeOptions = {}) =>
    createThemeCore({
        breakpoints: {
            values: {
                ...DEFAULT_BREAKPOINTS,
                ...breakpoints.values,
            },
        },
        componentStyles,
        colors,
    });

export const createThemes = (options: IThemeOptions) => ({
    theme: createTheme(options),
});

type IShowcaseThemeProviderProps = {
    theme: ITheme;
};

const ShowcaseThemeProvider: React.StatelessComponent<IShowcaseThemeProviderProps> = ({ theme, children }) => (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default ShowcaseThemeProvider;
